import { useForm } from "react-hook-form";
import { Button } from "@mantine/core";
import { useLocation } from "react-router-dom";

import { ItemType } from "../../types/enums";
import { STYLE } from "../../types/constants";
import SelectorButtonRef from "../SelectorButtonRef";
import SelectInputRef from "../SelectInputRef";
import ShadeSelection from "../shadeSelection";
import { deduceShadeType } from "../../utils/item.utils";
import { AnatomyItem } from "../../types/interfaces";
import { TeethShadeType } from "../../types/enums";

const CreateNewLay = ({
  productType,
  materialFormChoices,
  anatomyItemChoicesData,
  accountProductPreferences,
  order,
  onSubmit,
  item = null as AnatomyItem,
  isMultipleCaracteristicsByItem,
}) => {
  const location = useLocation();

  const getSavedItem = (
    isMultipleCaracteristicsByItem: boolean,
    item: AnatomyItem | AnatomyItem[]
  ) => {
    if (isMultipleCaracteristicsByItem && item) {
      return item;
    }
    const items = Array.isArray(item) ? item : item ? [item] : [];
    return items.find(
      (item: AnatomyItem) =>
        item.itemType === ItemType.ONLAY ||
        item.itemType === ItemType.INLAY ||
        item.itemType === ItemType.OVERLAY ||
        item.itemType === ItemType.LAY
    );
  };

  const savedItem = getSavedItem(isMultipleCaracteristicsByItem, item);

  const rhf = useForm({
    defaultValues: {
      layType: savedItem?.itemType,
      material: savedItem?.itemMaterial?.id,
      shade: savedItem?.itemShade?.id,
      shadeType: deduceShadeType(
        savedItem?.itemShade?.id,
        order?.user?.id,
        accountProductPreferences,
        savedItem?.teethshadeType === TeethShadeType.MULTI_SHADE,
        savedItem?.multiShadeInfo ?? []
      ),
    },
  });

  const watchLayType = rhf.watch("layType");
  const watchShadeType = rhf.watch("shadeType");
  const watchMaterial = rhf.watch("material");
  const watchIsMultiShade = rhf.watch("isMultiShade");

  return (
    <>
      {productType === ItemType.LAY && (
        <SelectorButtonRef
          label="Veuillez choisir un type de lay"
          data={[
            {
              label: "Inlay",
              value: ItemType.INLAY,
            },
            {
              label: "Onlay",
              value: ItemType.ONLAY,
            },
            {
              label: "Overlay",
              value: ItemType.OVERLAY,
            },
          ]}
          name="layType"
          onSubmit={selectedValue => rhf.setValue("layType", selectedValue)}
          control={rhf.control}
          errors={rhf.formState.errors}
          watch={watchLayType}
          required={true}
        />
      )}
      <SelectInputRef
        label="Matériau"
        name="material"
        data={materialFormChoices}
        control={rhf.control}
        errors={rhf.formState.errors}
        required={true}
      />
      {watchMaterial !== "METAL_NON_PRECIOUS" && (
        <ShadeSelection
          watchShadeType={watchShadeType}
          control={rhf.control}
          errors={rhf.formState.errors}
          anatomyItemChoicesData={anatomyItemChoicesData}
          onSelect={selectedValue => rhf.setValue("shadeType", selectedValue)}
          order={order}
          accountProductPreferences={accountProductPreferences}
          rhf={rhf}
          itemType={ItemType.LAY}
        />
      )}
      <div style={{ textAlign: "center" }}>
        <Button
          style={{ backgroundColor: STYLE.primary }}
          onClick={rhf.handleSubmit(data =>
            onSubmit(data, watchIsMultiShade, watchLayType, savedItem)
          )}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default CreateNewLay;
